/**
 *  Example usage:
 *  <video-gif class="block">
      {{ section.settings.video | video_tag: preload: "none", muted: true, autoplay: false, loop: true, playsinline: true, controls: false, image_size: '1440x', class: video_class }}
    </video-gif>
 */

if (!customElements.get('video-gif')) {
  /**
   * class VideoGif
   * @extends HTMLElement
   */
  class VideoGif extends HTMLElement {
    /** @type {HTMLVideoElement | null} */
    video = null;

    /** @type {IntersectionObserver | null} */
    observer = null;

    /** @type {{ threshold: number }} */
    options = {
      threshold: 0.25,
    };

    connectedCallback() {
      const video = this.querySelector('video');
      const options = JSON.parse(this.dataset.options || '{}');

      this.options = {
        ...this.options,
        ...options,
      };

      if (video) {
        this.video = video;
        this.initialize();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    observerCallback = (entries) => {
      entries.forEach((entry) => {
        const { target: video } = entry;

        if (entry.isIntersecting) {
          video.play().catch((e) => {
            // Handle play promise rejection if needed
            console.log('Video playback failed:', e);
          });
        } else {
          video.pause();
        }
      });
    };
    hasAudio(video) {
      if (
        (typeof video.mozHasAudio !== 'undefined' && video.mozHasAudio) ||
        (typeof video.webkitAudioDecodedByteCount !== 'undefined' &&
          video.webkitAudioDecodedByteCount > 0) ||
        Boolean(video.audioTracks?.length)
      ) {
        return true;
      } else {
        return false;
      }
    }

    initialize() {
      if (this.video) {
        // Ensure the video is muted and plays inline
        this.video.muted = true;

        this.video.setAttribute('playsinline', '');

        this.video.play().catch((e) => {
          console.log('Initial video playback failed:', e);
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.observerCallback, {
            threshold: this.options.threshold,
          });

          this.observer.observe(this.video);
        } else {
          this.video.play();
        }
        this.mute = this.querySelector('[data-video-gif="mute"]');
        if (this.mute) {
          //A timeout is needed to check if the video has audio as it is not immediately available
          setTimeout(() => {
            if (this.hasAudio(this.video)) {
              this.querySelector('[data-video-gif="mute"]').classList.remove('hidden');
            } else {
              this.querySelector('[data-video-gif="mute"]').classList.add('hidden');
            }
          }, 300);

          this.mute.addEventListener('click', () => {
            if (this.video.muted) {
              this.unmuteVideo();
            } else {
              this.muteVideo();
            }
          });
        }
      }
    }
    /**
     * unmuteVideo
     */
    unmuteVideo() {
      this.video.muted = false;

      this.classList.remove('muted');
    }

    /**
     * muteVideo
     */
    muteVideo() {
      this.video.muted = true;
      this.classList.add('muted');
    }
  }

  window.VideoGif = VideoGif;
  customElements.define('video-gif', VideoGif);
}
